import { isDefined } from '@sgme/fp';
import { HStack, VStack } from '@sgme/ui';

import RightColumnHeader from '@/App/tiles/ForwardAccumulator/parts/RightColumnHeader.tsx';
import { InputGroup1 } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/InputGroup1.tsx';
import { InputGroup2 } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/InputGroup2.tsx';
import { InputGroup3 } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/InputGroup3.tsx';
import { InputGroup4 } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/InputGroup4.tsx';
import Summary from '@/App/tiles/ForwardAccumulator/parts/RightPanel/Pricer/Summary.tsx';
import { useForwardAccumulatorTileId } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { AccumulatorPayoffGraph } from '@/components/ui/AccumulatorPayoffGraph.tsx';
import { selectForwardAccumulatorProperty } from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const PricerView = () => {
  const tileId = useForwardAccumulatorTileId();

  const clientsWay = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'clientsWay'));
  const akoTrigger = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'akoTrigger'));
  const ekiTrigger = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'ekiTrigger'));

  return (
    <VStack flex="expand" verticalAlignment="start" className="align-self-stretch">
      <RightColumnHeader />
      <HStack verticalAlignment="start" gap="24px" className="px-2">
        <div style={{ flexGrow: 0, width: 340 }}>
          <InputGroup1 />

          <div className="mt-3">
            <InputGroup2 />
          </div>

          <div className="mt-3">
            <InputGroup3 />
          </div>

          <div className="mt-3">
            <InputGroup4 />
          </div>
        </div>
        <VStack flex="expand">
          <Summary />
          <div className="mt-4" style={{ maxWidth: '300px' }}>
            <AccumulatorPayoffGraph
              productName="FxForwardAccumulator"
              way={clientsWay ?? 'Buy'}
              isAccumulatorTrigger={isDefined(akoTrigger) || isDefined(ekiTrigger)}
            />
          </div>
        </VStack>
      </HStack>
    </VStack>
  );
};

export default PricerView;
